import { filterCapitalize } from "@/filters/capitalize";
import { SelectItem } from "@/models/api/SelectItem";
import i18n from "@/plugins/i18n";

export enum NOTIFICATION_TRIGGER {
  OnCreate = 1,
  OnStatusUpdate = 2,
  OnReady = 3,
}

export const notificationTriggerSelect = [
  { value: NOTIFICATION_TRIGGER.OnCreate, text: filterCapitalize(i18n.t("onBookingCreate")) } as SelectItem,
  { value: NOTIFICATION_TRIGGER.OnStatusUpdate, text: filterCapitalize(i18n.t("onStatusUpdate")) } as SelectItem,
  { value: NOTIFICATION_TRIGGER.OnReady, text: filterCapitalize(i18n.t("onBookingReady")) } as SelectItem,
];
